import React, { useEffect, useState, useRef } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import Breadcrumb from '../../../components/common/breadcrumb';
import DynamicDataTables from '../commonComponent/DataTable/DynamicDataTable';
import { URL_Start } from '../../../constant';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import { Spinner } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ViewToolTip  from '../UI/ToolTips/ViewToolTip';
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import { useHistory } from 'react-router';

import EditToolTip from '../UI/ToolTips/EditToolTip';
import DeleteToolTip from '../UI/ToolTips/DeleteToolTip';
import SelfActiveToolTip from '../UI/ToolTips/SelfActiveToolTip';
import SelfInactiveToolTip from '../UI/ToolTips/SelfInactiveToolTip';
const DoctorMergingDetails = () => { 
    let textSearch = useRef();
    const [LoginId, setLoginId] = useState(localStorage.LoggedInUser == undefined ? "" : localStorage.LoggedInUser);
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const [tableData, setTableData] = useState([]);
    const [PageHelper, SetPageHelper] = useState({
        PageNo: '1',
        PageSize: '10',
        TotalRecord: 0,
        dsDoctorDlists: []

    });
    const paginationOptions = {

        totalSize: PageHelper.TotalRecord,
        sizePerPage: PageHelper.PageSize,
        showTotal: true,
        firstPageText: 'First',
        prePageText: 'Back',
        nextPageText: 'Next',
        lastPageText: 'Last',

        onSizePerPageChange: (sizePerPage, page, event) => {
            console.log('Size per page change!!!');
            console.log('Newest size per page:' + sizePerPage);
            console.log('Newest page:' + page);
           BindGrid(page, sizePerPage,textSearch.current.value.toLowerCase());
            document.getElementsByClassName('dropdown-menu show')[0].classList.remove('show')
        },
        onPageChange: (page, sizePerPage) => {
            console.log('Page change!!!');
            console.log('Newest size per page:' + sizePerPage);
            console.log('Newest page:' + page);
        BindGrid(page, sizePerPage,textSearch.current.value.toLowerCase());
        }
    };
    const ViewFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
        <div >
               <p><strong>UnMerge</strong> :  <DeleteToolTip title="UnMerge" onClick={()=>Displayalert(rowData.MergingSNo)} /></p>
        </div>
    </React.Fragment>
    }

    const OrgViewFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
        <div>
        <p><strong>Doctor Name:</strong> {rowData.OriginalDrName}</p>
        <p><strong>Doctor Specialization:</strong> {rowData.OrgDocSpecialization}</p>
        <p><strong>Doctor Location:</strong> {rowData.OrgFMLocation}</p>
        <p><strong>Doctor Mobile:</strong> {rowData.OrgDrMobile}</p>
        <p><strong>Salesman Detail:</strong> {rowData.OrgSalesman}</p>
        </div>
    </React.Fragment>
    }
    const MergeViewFormatter = (cellData, rowData, rowIndex, extraData) => {
        return <React.Fragment>
        <div>
        <p><strong>Doctor Name:</strong> {rowData.MergeDrName}</p>
        <p><strong>Doctor Specialization:</strong> {rowData.MergeDocSpecialization}</p>
        <p><strong>Doctor Location:</strong> {rowData.MergeFMLocation}</p>
        <p><strong>Doctor Mobile:</strong> {rowData.MergeDrMobile}</p>
        <p><strong>Salesman Detail:</strong> {rowData.MergeSalesman}</p>
        </div>
    </React.Fragment>
    }

    const columns = [{
        dataField: '#',
        text: '#',
        formatter: (cell, row, rowIndex) => {
          let rowNumber = (PageHelper.PageNo - 1) * PageHelper.PageSize + (rowIndex + 1);
          return <span>{rowNumber}</span>;
        },
        headerStyle: (colum, colIndex) => {
            return { width: '5%'};
            }
  
    },
    {
        text: 'Merge With Doctor Detail',
        formatter:OrgViewFormatter,
        editable: false 

    }
    ,
    {
        text: 'Merge This Doctor Detail',
        formatter:MergeViewFormatter,
        editable: false 

    },
   
    {
        dataField: 'actions',
        isDummyField: true,
        text: 'Actions',
        formatter: ViewFormatter,
        headerStyle: (colum, colIndex) => {
            return { width: '5%'};
            }
          

    }
    ];
   

    useEffect(() => { BindGrid(1,10,''); 
}, []);
   
    const handleSearch = async () => {

        BindGrid(1,10,textSearch.current.value.toLowerCase());
    
    }
    const BindGrid = async (PageNo, PageSize,SearchTxtInput) => {
        setIsLoading(true);
        try {
         
            let url=URL_Start + 'DoctorMaster/getdoctorMergeDetailMaster';
                let options = {
                    method: 'POST',
                    url: url,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: {  PageNo: `${PageNo}`, PageSize: `${PageSize}` ,SearchTxt:`${SearchTxtInput}` }
                };
                let response = await axios(options);
                let responseOK = response && response.status == 200;
                if (responseOK) {
                    let data = response.data;
    
                    // let data = await response.data;
                    if (data.Success == true) {
                        let ds = data.Data;
                        if (ds != null) {
    
                            await SetPageHelper({
                                ...PageHelper,
                                 PageNo:Number(PageNo),
                                PageSize: Number(PageSize),
                                TotalRecord: Number(ds.TotalRecord),
                                dsDoctorDlists: ds.ObjBindDoctorMergingList== null ? [] : ds.ObjBindDoctorMergingList
                            });
    
                            setIsLoading(false);
                        }
                    }
                    else {
                        let Errtext = <p><div className='text-required'> no record found </div></p>;
                    console.log('no record found');
                    setIsLoading(false);
                    }
    
                }
                else { SweetAlert.fire('There is some issue at server. We already know about it and working hard to get it fixed as soon as possible.'); setIsLoading(false); }
                // return data;
            } catch (error) {
                if (error.response) { ErrorFunction(error.response.status);
                    setIsLoading(false);
            }

        }
        }
    const ErrorFunction = async (ErrorCode) => {
        if (ErrorCode == "400")
            SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" })
        else if (ErrorCode == "401")
            SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" })
        else if (ErrorCode == "403")
            SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" })
        else if (ErrorCode == "404")
            SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" })
        else if (ErrorCode == "500")
            SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" })
        else if (ErrorCode == "503")
            SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" })
    }

    const newHandler = async () => {
        history.push({ pathname: `${process.env.PUBLIC_URL}/doctor-master/adddoctorMergingDetails`, search: `` });
        localStorage.removeItem('cId');
    }
    const Displayalert = (MergingSNo) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "you want unmerge doctor",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        })
            .then((result) => { if (result.value) { asyncFunDoctorUnmergeDetails(MergingSNo); } else { SweetAlert.fire('Your data is safe!'); } })
    }
    const asyncFunDoctorUnmergeDetails =async(MergingSNo)=> {
        try {
         
        let url=URL_Start+ 'DoctorMaster/SETInsertUpdateDoctorUnMergeDetails';
        let options = {
            method: 'POST',
            url: url,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: {AddedBy:`${LoginId}`, MergingSNo:`${MergingSNo}`}
        };
        let response = await axios(options);
            let responseOK = response && response.status == 200;
            if (responseOK) {
                let data = response.data;
                // let data = await response.data;
                if(data.Success==true)
                { let ds=data.Data;
                if(data.Success==true && data.Data=="2000")
                { 
                    SweetAlert.fire({ title: "Success!", text: "Doctor has been unmerge!", icon: "success" });
                    BindGrid(1,10,'');
                }
                }
                else{
                    let Errtext=<p><div className='text-required'> no record found </div></p>;
                    SweetAlert.fire({ title: "Error", text:"no record found", icon: "error" });
                    console.log('no record found');
                }
               
              
            }
            else{
                let Errtext=<p><div className='text-required'> no record found </div></p>;
                SweetAlert.fire({ title: "Error", text:"no record found", icon: "error" });
            }
         // return data;
        } catch (error) {
            console.log(error.message);
            let Errtext=<p><div className='text-required'>You may not be connected to a network or Unable to connect to a server</div></p>;
            SweetAlert.fire({ title: "Error", text:"You may not be connected to a network or Unable to connect to a server", icon: "error" });
         }
      }

    return (
        <React.Fragment>
            <Breadcrumb title="Merge Doctors" parent="Master" />
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                                <Form.Row className='justify-content-center'>
                                <Col lg={6} md={6} className="col-12">
                                        <Form.Group>
                                            <InputGroup className="mb-3">
                                            <Form.Control onChange={handleSearch} placeholder="Location OR Doctor Name OR Doctor Mobile OR Specialization ..." ref={textSearch} />
                                                <InputGroup.Append className="justify-content-md-center">
                                                    <Button variant="secondary" onClick={handleSearch}><i className='fa fa-search'></i></Button>
                                                </InputGroup.Append>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col lg={2} md={6} className="col-12 ">
                                        <Form.Group>
                                        <InputGroup className="mb-3 justify-content-md-center">
                                               <InputGroup.Append>
                                                    <Button variant='primary' type='submit' onClick={newHandler}>Add Doctor Merge</Button>
                                               </InputGroup.Append>
                                           </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col md={12} className='text-center'>
                                        {/* <Button variant='secondary' className="mr-2" onClick={handleSearch} >Search</Button> */}
                                        
                                    </Col>
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card>
                            <Card.Header className='pb-0'>
                                <Card.Title>Merge Doctor List</Card.Title>
                            </Card.Header>
                            <Card.Body>
                            {
                                    isLoading &&
                                    <div className='text-center'> <Spinner animation="border" size='sm' /></div>
                                }
                                     
                                             <DynamicDataTables keyField="DoctorId" tableData={PageHelper.dsDoctorDlists} columns={columns} pagination={paginationOptions ? paginationFactory(paginationOptions) : null} />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    )
}
export default DoctorMergingDetails;